module.exports = __webpack_public_path__ + "img/icon-21-gr.fcab7841.svg";